import React, { useState } from 'react';
import $ from 'jquery';
import '../Styles/CrossCulture.css'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import DiagrameImg from '../assets/images/Cross-culture-img.png'
import HappyClients from '../Components/HappyClients'
import BottomCarousel from '../Components/BottomCarousel'
import LeaderForm from '../Components/LearningForm';
import SkillMenuBar from '../Components/SkillMenuBar';

function CrossCultue() {
  
   $(document).ready(function(){
      $('.customer_carousel2').owlCarousel({
        loop:true,
        margin:0,
        
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        nav:false,
        dots:true,
        responsive:{
            0:{
                items:1
            },
            320:{
                items:1
            },
            480:{
                items:1
            },
            600:{
                items:1
            },
            767:{
                items:1
            },
            991:{
                items:1
            },
            1200:{
                items:2
            }
        }
    });
    });	
$(document).ready(function(){
$('.owl-carousel').owlCarousel({
items: 10, // Number of items visible at once
loop: true, // Loop the carousel
margin: 10, // Space between items
autoplay: true, // Autoplay the carousel
autoplayTimeout: 3000, // Autoplay interval in milliseconds
responsive: {
0: {
items: 1
},
768: {
items: 2
},
1024: {
items: 4
}
}
});
});
return (
<div className="App">
   <header className="header">
   <section className='backgroung-image-crossculture'>
       <Navbar/>
       <div className='header-about-content'>
         <h1>.</h1>
      </div>
      </section>
          {/* menu Start */}
          <SkillMenuBar/>
       {/* Header Menu End */}
   </header>
   <main className="main">
      <section className='container about-success'>
         <div className='Testimonials-success-work'>
            {/* <!------what start--------> */}
            <div className="testimonials-bg">
               <div className="container">
                     <h5> SERVICES</h5>
                     <h2><span>Cross</span> - Culture</h2>
                      <div className='row mt-5'>
                      <p>A cross-cultural understanding in today’s world is crucial for making life abroad easier and more successful. Organizations seeking to expand their cultural understanding, develop their cross-cultural skills. Our Trainings are customized for individual needs and addressing topics relevant to organizations seeking to expand their cultural understanding, develop their cross-cultural skills. All cross-cultural trainings are given on demand starts with a cross-cultural assessment. BRiX delivery methodology is inspiring and interactive. Our coaches and trainers mix, exercises and practical advice and empower your employees to be able to understand these differences and how to work across cultures. Our workshops cover a vast number of subjects such as 
                        <span>values, morals, ethics, business practices, etiquette, protocol, negotiation styles and safety issues.</span></p>
                   
                      </div>
                      
               </div>
            </div>
            {/* <!------success end--------> */}
         </div>
      </section>
        {/* program section start */}
        
      <section className='  program-sectionss'>
         <div className=" thisPractices">
            <div className="container">
               <img src={DiagrameImg} alt="ncnbdjcn"/>
            </div>
         </div>
      </section>
      {/* program section end */}
       {/* program form Inner start */}
       <LeaderForm/>
{/* program form end */}
 {/* Happy Clients Start */}
 <section className='Happy-clients'>
          <HappyClients/>
       </section>
      {/* Happy Clients END */}
      {/* Brand Section Start */}
      <BottomCarousel/>
      {/* Brand Section end */}
</main>
{/* <!------footer start--------> */}
<Footer/>
{/* <!------footer end--------> */}
</div>
);
}
export default CrossCultue;